import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/joy/IconButton";
import Tooltip from "@mui/joy/Tooltip";
import { SxProps } from "@mui/system";
import Box from "@mui/system/Box";

interface Props {
  text?: string;
  retry: Function;
  sx?: SxProps;
}

const ErrorFallback = ({ text, retry, sx }: Props) => {
  return (
    <Box
      sx={[
        {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {text || "Something went wrong!"}
      {
        <Tooltip title="Retry">
          <IconButton
            onClick={() => retry()}
            size="sm"
            sx={{
              ml: 1,
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      }
    </Box>
  );
};
export default ErrorFallback;
